/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { CloudState } from './types';
import { RootState } from '../types';

export const state: CloudState = {
  clouds: {
    data: undefined,
    error: undefined,
    status: undefined,
  },
  renew: {
    data: undefined,
    error: undefined,
    status: undefined,
  },
};

const namespaced = true;

export const cloud: Module<CloudState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
